export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  title: ' ',
  format: 'categories',
  options: {
    infoText: 'The name of a table containing resources to be restricted',
    disable_properties: false,
    disable_edit_json: false
  },
  additionalProperties: {
    type: 'array',
    options: {
      array_controls_top: true
    },
    items: {
      anyOf: [
        { $ref: '#/definitions/arrayOfRestrictions' },
        { $ref: '#/definitions/restriction' }
      ]
    }
  },
  definitions: {
    arrayOfRestrictions: {
      type: 'array',
      title: 'Restriction Group (OR)',
      options: {
        array_controls_top: true
      },
      items: {
        $ref: '#/definitions/restriction'
      }
    },
    restriction: {
      type: 'object',
      title: 'Restriction',
      additionalProperties: false,
      properties: {
        column: {
          type: 'string'
        },
        operator: {
          type: 'string',
          enum: ['is', 'is not', '=', '!=', 'in', 'not in', '>', '>=', '<', '<=', 'like']
        },
        constraint: {
          type: 'object',
          properties: {
            type: {
              type: 'string',
              enum: ['relative_time', 'primitive']
            },
            value: {}
          },
          required: ['type', 'value']
        }
      },
      required: ['column', 'operator', 'constraint']
    }
  }
}
